import * as React from 'react';

import {FeatureGateModalWrapper} from '../../../limits/feature-gates/feature-gate-modal-wrapper';

type Props = {
    isOpen: boolean;
    onClose: () => void;
};

export function DirectorySyncFeatureGateModal(props: Props) {
    return (
        <FeatureGateModalWrapper
            isOpen={props.isOpen}
            onClose={props.onClose}
            title='Sync users from your identity provider'
            description='Use directory sync to externally manage users in Nutshell.'
            bullets={[
                'Adding users to your identity provider directory will add them as users within Nutshell.',
                'Removing users from your identity provider directory will remove them from Nutshell.',
                'Requires at least 10 Nutshell users.',
            ]}
            feature='directorySync'
        />
    );
}
